module.exports = __webpack_public_path__ + "assets/img/18_185_big.68269149.jpg";